import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const ListPosition = createAsyncThunk(
  'school-position-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-position/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createPosition = createAsyncThunk(
  'school-position-create',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-position/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const editPosition = createAsyncThunk(
  'school-position-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-position/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const togglePosition = createAsyncThunk(
  'school-position-toggle',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-position/toggle/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const viewPosition = createAsyncThunk(
  'school-position-view',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-position/view/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type PositionState = {
  errors: any
}

const initialState: PositionState = {
  errors: '',
}

export const positionSlice = createSlice({
  name: 'school-position',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createPosition.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = positionSlice.actions
export default positionSlice.reducer
